
window.dragElementById = function (id) {
    var draggable = document.getElementById(id);
    //dragElement(draggable);
    this.setTimeout(function () { dragElement(draggable); }, 1)
};

function dragElement(elmnt) {
    var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
    var element = document.getElementById("header-" + elmnt.id);
    element.onmousedown = dragMouseDown;

    //set modal to center
    var modalWith = elmnt.getBoundingClientRect().width;
    var windowSize = document.body.getBoundingClientRect().width;

    if (modalWith < windowSize) {
        var left = windowSize / 2;
        left = left - (modalWith / 2);
        elmnt.style.left = left + "px";
    } else {
        elmnt.style.left = "2%";
        elmet.style.width = "95%";
    }

    elmnt.style.top = "25px";

    function dragMouseDown(e) {
        e = e || window.event;
        e.preventDefault();
        // get the mouse cursor position at startup:
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.addEventListener('mouseup', closeDragElement);
        // call a function whenever the cursor moves:
        document.addEventListener('mousemove', elementDrag);
    }

    function elementDrag(e) {
        e = e || window.event;
        e.preventDefault();
        // calculate the new cursor position:
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
        // set the element's new position:
        elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
        elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
    }

    function closeDragElement() {
        /* stop moving when mouse button is released:*/
        document.removeEventListener('mouseup', closeDragElement);
        document.removeEventListener('mousemove', elementDrag);
    }
}